import TerminosCondiciones from "./components/TerminosCondiciones";
import PoliticaPrivacidad from "./components/PoliticaPrivacidad";
import AdminFeriados from "./components/AdminFeriados";
import React, { Suspense, lazy } from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { AuthProvider, useAuth } from "./AuthContext";

//  APLICANDO LAZY LOADING PARA REDUCIR LA "NETWORK DEPENDENCY TREE" 
const Home = lazy(() => import("./components/Home"));
const Property = lazy(() => import("./components/Property"));
const Properties = lazy(() => import("./components/Properties"));
const Sale = lazy(() => import("./components/Sale"));
const Rent = lazy(() => import("./components/Rent"));
const Login = lazy(() => import("./components/Login"));
const NewProperty = lazy(() => import("./components/NewProperty"));
const UpdateProperty = lazy(() => import("./components/UpdateProperty"));
const PanelAdmin = lazy(() => import("./components/PanelAdmin"));
const PropertiesPanel = lazy(() => import("./components/PropertiesPanel").then(module => ({ default: module.PropertiesPanel })));
const CategoriesPanel = lazy(() => import("./components/CategoriesPanel"));
const UsuariosPanel = lazy(() => import("./components/UsuariosPanel"));
const ConsultasPanel = lazy(() => import("./components/ConsultasPanel"));
const ComentariosPanel = lazy(() => import("./components/ComentariosPanel"));

const ScreenLoader = () => (
  <div className="flex items-center justify-center min-h-[50vh] w-full bg-[#fcfcfd]">
    <div className="w-12 h-12 border-4 border-[#eef5fd] border-l-[#0037A3] rounded-full animate-spin"></div>
  </div>
);

const PrivateRoutes = () => {
  const { currentUser } = useAuth();
  return currentUser ? <Outlet /> : <Navigate to="/login" />;
};

const App = () => {
  return (
    <AuthProvider>
      <Navbar />
      <Suspense fallback={<ScreenLoader />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/sale" element={<Sale />} />
          <Route path="/rent" element={<Rent />} />
          <Route path="/login" element={<Login />} />
          <Route path="/properties" element={<Properties />} />
          <Route path="/properties/:id" element={<Property />} />
          <Route path="/terminos-y-condiciones" element={<TerminosCondiciones />} />
          <Route path="/politica-de-privacidad" element={<PoliticaPrivacidad />} />

          <Route element={<PrivateRoutes />}>
            <Route path="/properties/create" element={<NewProperty />} />
            <Route path="/properties/change/:id" element={<UpdateProperty />} />
            <Route path="/panelAdmin" element={<PanelAdmin />}>
              <Route index element={<PropertiesPanel />} />
              <Route path="propiedades" end element={<PropertiesPanel />} />
              <Route path="consultas" element={<ConsultasPanel />} />
              <Route path="usuarios" element={<UsuariosPanel />} />
              <Route path="categorias" element={<CategoriesPanel />} />
              <Route path="comentarios" element={<ComentariosPanel />} />
              <Route path="feriados" element={<AdminFeriados />} />
            </Route>
          </Route>
        </Routes>
      </Suspense>
      <Footer />
    </AuthProvider>
  );
};

export default App;